module.exports = {
      id: "technology-usage",
      viewBox: "0 0 22.958 22.633",
      url: "/" + "sprite-bc0169963456b1a4ad1bb8f1c406f483.svg#technology",
      toString: function () {
        return this.url;
      }
    }